/// <amd-module name="Release/Landing/HubContent/DeploymentsPivot" />
import * as React from "react";

import { VssComponent, IVssComponentProperties, IVssComponentContext } from "VSS/Platform/Layout";
import { ErrorBoundary } from "VSS/Platform/Components/ErrorBoundary";

import { startScenario, PerfScenarios, endScenario, markTimeToInteractive } from "Release/Helpers/Performance";
import { ActiveDefinitionReferenceType } from "Release/Landing/DataProviderContracts";
import { SelectPipelineView } from "./SelectPipelineView";
import { DeploymentsView } from "./Deployments/Deployments";
import { IDeploymentsFilterState } from "./Filter/FilterTypes";
import * as Resources from "Release/Landing/Resources";

import "VSS/LoaderPlugins/Css!RM:Release/Landing/HubContent/DeploymentsPivot";

export interface IDeploymentsPivotProps extends IVssComponentProperties {
    definitionId: number;
    definitionName: string;
    definitionFolderPath: string;
    selectedFolderPath: string;
    isSearchedItem: boolean;
    isTabSwitchNavigation: boolean;
    definitionReferenceType: ActiveDefinitionReferenceType;
    filterState: IDeploymentsFilterState;
    markTTICallback: () => void;
}

export class DeploymentsPivot extends VssComponent<IDeploymentsPivotProps, {}>{
    constructor(props: IDeploymentsPivotProps, context: IVssComponentContext) {
        super(props, context);

        startScenario(context.pageContext, PerfScenarios.DeploymentsPivot, false);
    }

    public componentWillReceiveProps(newProps: IDeploymentsPivotProps) {
        if (!newProps.isTabSwitchNavigation && newProps.definitionId !== this.props.definitionId) {
            // Start perf scenario on selection change in leftPanel
            startScenario(this.context.pageContext, PerfScenarios.ReleasesPivot, false);
            this._deploymentsLoadMarked = false;
        }
    }

    public render(): React.ReactNode {
        if (this.props.selectedFolderPath) {
            // TODO - wait for spec on view to be shown on folder selection
            // @ts-ignore Looks like this may be a bug, but we will avoid touching this old code.
            setTimeout(this._endPerfScenarioCallback(), 0);
            return (<SelectPipelineView resourceText={Resources.ReleasesLowerCase} />);
        }

        if (this.props.definitionId <= 0) {
            return (<SelectPipelineView resourceText={Resources.ReleasesLowerCase} />);
        }

        return (
            <ErrorBoundary handlerComponentType="tfs.page-error-handler">
                <DeploymentsView
                    definitionId={this.props.definitionId}
                    definitionName={this.props.definitionName}
                    definitionReferenceType={this.props.definitionReferenceType}
                    folderPath={this.props.definitionFolderPath}
                    isSearchedItem={this.props.isSearchedItem}
                    endPerfScenarioCallback={() => this._endPerfScenarioCallback()}
                    filterState={this.props.filterState}
                />
            </ErrorBoundary>);
    }

    private _endPerfScenarioCallback = () => {
        // End ReleasesHub perf scenario when Releases loading is complete
        if (!this.props.isTabSwitchNavigation) {
            this.props.markTTICallback();
        }

        //End ReleasesPivot scenario when -
        // 1. there is a selection change in left panel
        // 2. or initial page load is complete
        // 3. or Right pivot change
        if (!this._deploymentsLoadMarked) {
            endScenario(this.context.pageContext, PerfScenarios.ReleasesPivot, false);
            this._deploymentsLoadMarked = true;
        }
    }

    private _deploymentsLoadMarked: boolean = false;
}
